import { http } from '../../config/axios'

export interface PasskeyCredencial {
  id: number
  nomeDispositivo?: string
  dataCriacao?: string
  dataUltimoUso?: string
}

const getUserPasskeys = (): Promise<PasskeyCredencial[]> => {
  return http
    .get('api/user/passkey')
    .then((res) => {
      return res.data as PasskeyCredencial[]
    })
    .catch((error) => {
      console.error('Erro getUserPasskeys', error)
      throw Error(error.response?.data)
    })
}

export default getUserPasskeys
